export default __webpack_public_path__ + "static/media/RELEASE_BLOCKS_ICON_GREEN.83bc7943.svg";